import { Injectable } from '@angular/core'
import { orderBy } from 'lodash'
import { BehaviorSubject, debounceTime, map, shareReplay, startWith, Subject, switchMap, tap } from 'rxjs'

import { ReferrerModel } from '../model/referrer'
import { CrudService } from './crud.service'

@Injectable({
  providedIn: 'root',
})
export class ReferrersService {
  public loading$ = new BehaviorSubject(true)
  public refresh$ = new Subject<void>()

  public referrers$ = this.refresh$.pipe(
    startWith(null),
    debounceTime(100),
    tap(() => this.loading$.next(true)),
    switchMap(() => this.crudService.index(ReferrerModel)),
    tap(() => this.loading$.next(false)),
    map(resources => orderBy(resources, 'viewValue')),
    shareReplay(1),
  )

  constructor(private crudService: CrudService) { }
}
